'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var index = require('../Icon/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const ImageContainer = styled__default["default"].div.withConfig({
  componentId: "sc-16d7nyz-0"
})(_ref => {
  let {
    s,
    sMobile
  } = _ref;
  return {
    display: 'flex',
    justifyContent: 'center',
    height: 150,
    width: 150,
    position: 'relative',
    '@media screen and (max-width: 768px)': {
      height: 96,
      width: 96,
      ...sMobile
    },
    ...s
  };
});
const StyledImg = styled__default["default"].img.withConfig({
  componentId: "sc-16d7nyz-1"
})(["max-width:100%;max-height:100%;height:auto;width:auto;"]);
const ItemImage = _ref2 => {
  let {
    src,
    alt,
    sDefault,
    sFallback,
    sMobile
  } = _ref2;
  const [usePlaceholder, setUsePlaceholder] = React.useState(false);
  if (usePlaceholder) {
    return /*#__PURE__*/React__default["default"].createElement(ImageContainer, {
      s: sFallback,
      sMobile: sMobile
    }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
      icon: "PlaceholderThumbnail"
    }));
  }
  return /*#__PURE__*/React__default["default"].createElement(ImageContainer, {
    s: sDefault,
    sMobile: sMobile
  }, typeof src === 'string' ? /*#__PURE__*/React__default["default"].createElement(StyledImg, {
    alt: alt,
    src: src,
    onError: () => setUsePlaceholder(true)
  }) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(StyledImg, {
    alt: alt,
    src: (src === null || src === void 0 ? void 0 : src.new) || '',
    onError: () => setUsePlaceholder(true)
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      position: 'absolute',
      left: 0,
      bottom: 0,
      width: '30%',
      height: '30%'
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React__default["default"].createElement(StyledImg, {
    alt: alt,
    src: (src === null || src === void 0 ? void 0 : src.old) || '',
    onError: () => setUsePlaceholder(true)
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      position: 'absolute',
      top: '-11px',
      right: '-11px'
    }
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    icon: "Exchange"
  }))))));
};

exports["default"] = ItemImage;
